import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import { createBatch } from "@/api/couponConfig.js";
import { getChannelMap } from "@/utils/dictionary";
export default {
  props: {
    data: {
      type: Object
    }
  },
  data: function data() {
    return {
      maxNum: 5000,
      num: 100,
      remark: '',
      channelMap: {},
      isAllChannel: true,
      channelCheckedList: []
    };
  },
  created: function created() {
    this.init();
  },
  computed: {
    channelList: function channelList() {
      var channelIds = Object.keys(this.channelMap);
      channelIds.sort();
      var ary = [];
      for (var _i = 0, _channelIds = channelIds; _i < _channelIds.length; _i++) {
        var id = _channelIds[_i];
        ary.push({
          label: this.channelMap[id],
          value: id
        });
      }
      return ary;
    }
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getChannelMap();
            case 2:
              _this.channelMap = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onConfirm: function onConfirm() {
      var _this2 = this;
      if (!this.isAllChannel) {
        if (this.channelCheckedList.length == 0) {
          this.$message.error('请选择渠道 或 选择全渠道');
          return;
        }
      } else {
        this.channelCheckedList = [];
      }
      if (this.num > this.maxNum) {
        this.$message.error("\u793C\u5305\u7801\u6570\u91CF\u4E0D\u80FD\u8D85\u8FC7".concat(this.maxNum));
      } else {
        var remark = this.remark.trim();
        this.$confirm("\u793C\u5305\u7801\u6570\u91CF\uFF08".concat(this.num, "\uFF09").concat(remark ? " \u5907\u6CE8\uFF08".concat(remark, "\uFF09") : '', " \u786E\u8BA4\u751F\u6210\uFF1F"), "提示").then(function () {
          createBatch({
            coupon_id: _this2.data.coupon_id,
            code_count: _this2.num,
            remark: _this2.remark.trim(),
            channel: _this2.channelCheckedList
          }).then(function (res) {
            if (res.code == 0) {
              _this2.$emit("generateDone");
            }
          });
        }).catch(function () {});
      }
    }
  }
};